<template>
  <div class="portfolio-wrapper min-h-screen bg-background text-foreground">
    <HamburgerMenu />
    <router-view />
  </div>
</template>

<script setup>
import HamburgerMenu from "./components/HamburgerMenu.vue";
</script>
<style scoped>
.portfolio-wrapper {
  overflow-x: hidden;
  scrollbar-width: none;
}
</style>
